module.exports = __webpack_public_path__ + "static/media/denim-jeans.96397e35.jpeg";